"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _OrdersContext = _interopRequireDefault(require("./OrdersContext"));

// import OrdersActionsProvider from '../OrdersActionsProvider';
function OrdersProvider(_ref) {
  var cacheHook = _ref.cacheHook,
      children = _ref.children,
      clientCode = _ref.clientCode,
      ContactSelectFieldPreview = _ref.ContactSelectFieldPreview,
      ContactSelectFieldPreviewNaked = _ref.ContactSelectFieldPreviewNaked,
      productDetailRouteBuilder = _ref.productDetailRouteBuilder,
      ProductImageComponent = _ref.ProductImageComponent,
      ProductParametersComponent = _ref.ProductParametersComponent,
      serviceNames = _ref.serviceNames,
      uiRouteBase = _ref.uiRouteBase;
  return /*#__PURE__*/_react.default.createElement(_OrdersContext.default.Provider, {
    value: {
      cacheHook: cacheHook,
      clientCode: clientCode,
      // CommissionFieldPreview,
      // ContactSelectField,
      ContactSelectFieldPreview: ContactSelectFieldPreview,
      ContactSelectFieldPreviewNaked: ContactSelectFieldPreviewNaked,
      // OfferSelectField,
      // OfferSelectFieldPreview,
      // OfferSelectFieldPreviewNaked,
      // OpportunitySelectField,
      // OpportunitySelectFieldPreview,
      // OpportunitySelectFieldPreviewNaked,
      // productAmountOnStockFormattedHook,
      // ProductSelectField,
      // ProductSelectFieldPreview,
      // ProductSelectFieldPreviewNaked,
      // SalesMarginFieldPreview,
      // ScoringBlogContent,
      productDetailRouteBuilder: productDetailRouteBuilder,
      ProductImageComponent: ProductImageComponent,
      ProductParametersComponent: ProductParametersComponent,
      serviceNames: serviceNames,
      uiRouteBase: uiRouteBase // UnitOfMeasureCodeFieldPreview,

    }
  }, children);
}

OrdersProvider.propTypes = {
  /**
   * Hook funkce vracejici cache.
   */
  cacheHook: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.array]),
  children: _propTypes.default.node,
  clientCode: _propTypes.default.string,
  // CommissionFieldPreview: PropTypes.elementType,
  // ContactSelectField: PropTypes.elementType.isRequired,
  ContactSelectFieldPreview: _propTypes.default.elementType.isRequired,
  ContactSelectFieldPreviewNaked: _propTypes.default.elementType.isRequired,
  productDetailRouteBuilder: _propTypes.default.func,
  ProductImageComponent: _propTypes.default.elementType,
  ProductParametersComponent: _propTypes.default.elementType,
  // OfferSelectField: PropTypes.elementType,
  // OfferSelectFieldPreview: PropTypes.elementType,
  // OfferSelectFieldPreviewNaked: PropTypes.elementType,
  // OpportunitySelectField: PropTypes.elementType.isRequired,
  // OpportunitySelectFieldPreview: PropTypes.elementType.isRequired,
  // OpportunitySelectFieldPreviewNaked: PropTypes.elementType.isRequired,
  // productAmountOnStockFormattedHook: PropTypes.oneOfType([PropTypes.func, PropTypes.array]).isRequired,
  // ProductSelectField: PropTypes.elementType.isRequired,
  // ProductSelectFieldPreview: PropTypes.elementType.isRequired,
  // ProductSelectFieldPreviewNaked: PropTypes.elementType.isRequired,
  // SalesMarginFieldPreview: PropTypes.elementType,
  // ScoringBlogContent: PropTypes.elementType.isRequired,
  serviceNames: _propTypes.default.shape({
    tenants: _propTypes.default.shape({
      get: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.arrayOf(_propTypes.default.string)]),
      list: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.arrayOf(_propTypes.default.string)]),
      remove: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.arrayOf(_propTypes.default.string)]),
      serviceName: _propTypes.default.string,
      update: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.arrayOf(_propTypes.default.string)]),
      version: _propTypes.default.string
    })
  }),
  uiRouteBase: _propTypes.default.string // UnitOfMeasureCodeFieldPreview: PropTypes.elementType.isRequired,

};
OrdersProvider.defaultProps = {
  cacheHook: undefined,
  children: null,
  clientCode: 'api',
  // CommissionFieldPreview: undefined,
  // OfferSelectField: undefined,
  // OfferSelectFieldPreview: undefined,
  // OfferSelectFieldPreviewNaked: undefined,
  // SalesMarginFieldPreview: undefined,
  productDetailRouteBuilder: undefined,
  ProductImageComponent: undefined,
  ProductParametersComponent: undefined,
  serviceNames: undefined,
  uiRouteBase: '/orders'
};
var _default = OrdersProvider;
exports.default = _default;